import Checkbox from './Checkbox'
import CheckboxGroup from './CheckboxGroup'

Checkbox.CheckboxGroup = CheckboxGroup

export default Checkbox

export {
  CheckboxGroup
}
